import { createBrowserRouter, RouteObject } from 'react-router-dom';

import Login from '../pages/login';
import authLoader from './loaders/authLoader';
import HydrateFallback from './hydrate-fallback/HydrateFallback';
import Home from '../pages/home';
import Admin from '../pages/home/admin';
import AuditoryShip from '../pages/home/port-management/ships';
import Carriers from '../pages/home/port-management/carriers';
import PortManagement from '../pages/home/port-management';
import Monitoring from '../pages/home/monitoring';
import NewMaintenance from '../pages/home/maintenance/new';
import Maintenance from '../pages/home/maintenance';
import MovementAuto from '../pages/home/movement/auto';
import Containers from '../pages/home/port-management/containers';
import Materials from '../pages/home/port-management/materials';
import Harbors from '../pages/home/admin/harbors';
import Client from '../pages/home/admin/clients';
import Users from '../pages/home/admin/users';
import Contacts from '../pages/home/admin/contacts';
import monitoringLoader from './loaders/monitorLoader';
import adminLoader from './loaders/adminLoader';
import movementLoader from './loaders/movementLoader';
import maintenanceLoader from './loaders/maintenanceLoader';
import RequestPasswordReset from '../pages/reset-password';
import ResetPassword from '../pages/reset-password/reset';
import resetPasswordLoader from './loaders/resetPasswordLoader';
import Help from '../pages/home/help';
import Reports from '../pages/home/reports';
import Financial from '../pages/home/financial';
import EnergyCost from '../pages/home/port-management/energy-cost';
import Queries from '../pages/home/queries';
import ContainerReports from '../pages/reports';
import Movement from '../pages/home/movement';
import MovementManual from '../pages/home/movement/manual';
import AuditoryTravel from '../pages/home/port-management/travel';
import AuditoryMonitoring from '../pages/home/port-management/monitoring';
import AuditoryReturn from '../pages/home/port-management/return';
import AuditoryMaintenance from '../pages/home/port-management/maintenance';
import Profile from '../pages/home/profile';
import MaintenanceLayout from '../pages/reports/maintenance';
import Chatbot from '../pages/home/chatbot';
import FluxoUnico from '../pages/fluxo-unico';
import ScrollBackAuditoria from '../pages/home/scrollback-auditoria';

const routes: RouteObject[] = [
	{
		path: '/',
		id: 'home',
		element: <Home />,
		HydrateFallback: HydrateFallback,
		loader: authLoader,
		children: [
			{
				path: 'monitor',
				element: <Monitoring />,
				loader: monitoringLoader,
			},
			{
				path: 'port_management',
				element: <PortManagement />,
				loader: adminLoader,
				children: [
					{
						path: 'return',
						element: <AuditoryReturn />,
					},
					{
						path: 'travels',
						element: <AuditoryTravel />,
					},
					{
						path: 'ships',
						element: <AuditoryShip />,
					},
					{
						path: 'monitoring',
						element: <AuditoryMonitoring />,
					},
					{
						path: 'carriers',
						element: <Carriers />,
					},
					{
						path: 'materials',
						element: <Materials />,
					},
					{
						path: 'containers',
						element: <Containers />,
					},
					{
						path: 'maintenance',
						element: <AuditoryMaintenance />,
					},
					{
						path: 'energy_cost',
						element: <EnergyCost />,
					},
				],
			},
			{
				path: 'admin',
				element: <Admin />,
				loader: adminLoader,
				children: [
					{
						path: 'clients',
						element: <Client />,
					},
					{
						path: 'users',
						element: <Users />,
					},
					{
						path: 'contacts',
						element: <Contacts />,
					},
					{
						path: 'harbors',
						element: <Harbors />,
					},
				],
			},
			{
				path: 'movement',
				element: <Movement />,
				loader: movementLoader,
				children: [
					{
						path: 'auto',
						element: <MovementAuto />,
					},
					{
						path: 'manual',
						element: <MovementManual />,
					},
				],
			},
			{
				path: 'maintenance',
				element: <Maintenance />,
				loader: maintenanceLoader,
				children: [
					{
						path: 'new',
						element: <NewMaintenance />,
					},
				],
			},
			{
				path: 'queries',
				element: <Queries />,
			},
			{
				path: 'reports',
				element: <Reports />,
			},
			{
				path: 'financial',
				element: <Financial />,
			},
			{
				path: 'help',
				element: <Help />,
			},
			{
				path: 'profile',
				element: <Profile />,
			},
			{
				path: 'chatbot',
				element: <Chatbot />,
			},
			{
				path: 'container_auditoria',
				element: <ScrollBackAuditoria />,
			},
		],
	},
	{
		path: 'login',
		element: <Login />,
	},
	{
		path: 'container-tracking',
		element: <FluxoUnico />,
	},
	{
		path: 'reset_password',
		element: <RequestPasswordReset />,
	},

	{
		path: 'reset_password/:token',
		loader: resetPasswordLoader,
		element: <ResetPassword />,
	},
	{
		path: 'reports/data',
		HydrateFallback: HydrateFallback,
		loader: authLoader,
		element: <ContainerReports />,
	},
	{
		path: 'reports/maintenance/data',
		HydrateFallback: HydrateFallback,
		loader: authLoader,
		element: <MaintenanceLayout />,
	},
];

// Instance all routes
const router = createBrowserRouter(routes, {
	future: {
		v7_skipActionErrorRevalidation: true,
		v7_relativeSplatPath: true,
		v7_fetcherPersist: true,
		v7_normalizeFormMethod: true,
		v7_partialHydration: true,
	},
});

export default router;
